'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

const Pill: FC<{
    header: ReactNode
    title: ReactNode
    backgroundImageSrc: string
    sx?: SxProps
}> = ({ title, header, backgroundImageSrc, sx }) => {
    const { mdScreen } = useDevice()
    return (
        <Box
            sx={{
                backgroundImage: `url(${backgroundImageSrc})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                width: '100%',
                padding: '32px',
                borderRadius: '24px',
                ...(sx ?? {}),
            }}
        >
            <Text variant={'button'}>{header}</Text>
            <Text variant={mdScreen ? 'h5' : 'h4'}>{title}</Text>
        </Box>
    )
}

export default Pill
